import bomb from './bomb.svg';
import bottle from './bottle.svg';
import broomStick from './broomstick.svg';
import compass from './compass.svg';
import fireball from './fireball.svg';
import potionBottle from './potionBottle.svg';
import rocket from './rocket.svg';
import satellite from './satellite.svg';
import wand from './wand.svg';



const characterAccessories = [
  {
    avatar: 'pirate',
    accessory: 'compass',
    imgSrc: compass,
  },
  {
    avatar: 'pirate',
    accessory: 'bottle',
    imgSrc: bottle,
  },
  {
    avatar: 'pirate',
    accessory: 'bomb',
    imgSrc: bomb,
  },
  {
    avatar: 'space explorer',
    accessory: 'fireball',
    imgSrc: fireball,
  },
  {
    avatar: 'space explorer',
    accessory: 'rocket',
    imgSrc: rocket,
  },
  {
    avatar: 'space explorer',
    accessory: 'satellite',
    imgSrc: satellite,
  },
  {
    avatar: 'wizard',
    accessory: 'wand',
    imgSrc: wand,
  },
  {
    avatar: 'wizard',
    accessory: 'broomStick',
    imgSrc: broomStick,
  },
  {
    avatar: 'wizard',
    accessory: 'potionBottle',
    imgSrc: potionBottle,
  },
  ]

export { characterAccessories }

